import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { CONSTANTS } from '../constants/constants';

// Import translation files
import en from '../locales/en.json';
import fr from '../locales/fr.json';

const translations = { en, fr };

// Helper function to resolve nested keys like 'buttons.submit'
const getNestedTranslation = (obj, key) => {
  const keys = key.split('.');
  let current = obj;

  for (const k of keys) {
    if (current === undefined || current === null) {
      return undefined;
    }
    current = current[k];
  }
  return current;
};

export const useTranslationStore = create(
  persist(
    (set, get) => ({
      language: CONSTANTS.LOCALES.EN,

      setLanguage: (newLanguage) => {
        if (translations[newLanguage]) {
          set({ language: newLanguage });
        } else {
          console.warn(`Language '${newLanguage}' is not supported.`);
        }
      },
    }),
    {
      name: 'locale-storage',
      partialize: (state) => ({ language: state.language }),
    }
  )
);

// Create a custom hook that will re-render components when language changes
export const useTranslation = () => {
  const language = useTranslationStore(state => state.language);
  
  const t = (key, options) => {
    let translation = getNestedTranslation(translations[language], key);

    // Fallback logic
    if (translation === undefined) {
      console.warn(`Translation missing for key: "${key}" in language: "${language}"`);
      translation = getNestedTranslation(translations.en, key) || key;
    }

    if (options && translation) {
      Object.keys(options).forEach(optKey => {
        translation = translation.replace(`{{${optKey}}}`, options[optKey]);
      });
    }

    if (options?.count !== undefined && options.count !== 1) {
      const pluralKey = `${key}_plural`;
      const pluralTranslation = getNestedTranslation(translations[language], pluralKey);
      if (pluralTranslation) {
        translation = pluralTranslation;
        Object.keys(options).forEach(optKey => {
          translation = translation.replace(`{{${optKey}}}`, options[optKey]);
        });
      }
    }

    return translation;
  };

  return { t, language };
};

export const availableLanguages = Object.keys(translations);